"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const swiper_1 = __importDefault(require("../helpers/swiper/swiper"));
/**
  * Add swiping to tabs element, like Highlight with tabs
  *
  * @param {HTMLElement} el - js-tabs
  * @returns {void}
  *
  *
 */
const Tabs = {
    swiper: null,
    swiperIndex: 0,
    init(el) {
        console.log('Init Tabs');
        this.el = el;
        this.swiperEl = el.querySelector('.js-swiper-container');
        if (el.dataset.swiperIndex) {
            this.swiperIndex = parseInt(el.dataset.swiperIndex);
        }
        if (this.swiperEl) {
            const self = this;
            const swiper = new swiper_1.default(this.swiperEl, {
                speed: 500,
                allowTouchMove: true,
                keyboard: true,
                spaceBetween: 1,
                watchSlidesProgress: true,
                slidesPerView: "auto",
                navigation: {
                    nextEl: `.js-swiper-next-${self.swiperIndex}`,
                    prevEl: `.js-swiper-prev-${self.swiperIndex}`
                },
            });
        }
    }
};
exports.default = Tabs;
